'use client';

import { motion } from 'framer-motion';

const clients = [
    { name: 'Astra Automations', sector: 'Tecnología' },
    { name: 'C22 Calisthenics', sector: 'Deporte' },
    { name: 'Moa Society', sector: 'Lifestyle' },
    { name: 'ClarisCoaching', sector: 'Coaching' },
    { name: 'OVB Allianz', sector: 'Finanzas' },
];

export default function TrustBar() {
    return (
        <section className="py-10 relative z-10">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="flex flex-col items-center gap-5">
                    <p className="text-xs font-mono tracking-[0.25em] text-slate-400 uppercase">
                        Negocios que ya hemos analizado
                    </p>

                    <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
                        {clients.map((c, i) => (
                            <motion.div
                                key={c.name}
                                initial={{ opacity: 0, y: 8 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: i * 0.08, duration: 0.5 }}
                                className="flex items-center gap-2"
                            >
                                <span className="text-sm font-semibold text-slate-700">{c.name}</span>
                                <span className="text-xs text-slate-400 hidden sm:inline">· {c.sector}</span>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
